import React, { useState } from 'react';
import { supabase } from '../supabaseClient';
import SessionNotice from './SessionNotice';

function LoginScreen({ onLogin, onBack, initialMode, signedOutNotice }) {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);
  const [mode, setMode] = useState(initialMode || 'signup');
  const [resetSent, setResetSent] = useState(false);

  const handleSignUp = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError(null);
    const { data, error } = await supabase.auth.signUp({ email, password });
    if (error) {
      setError(error.message);
      setLoading(false);
    } else if (data.session) {
      onLogin(data.session);
      setLoading(false);
    } else {
      setError('check_email');
      setLoading(false);
    }
  };

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError(null);
    const { data, error } = await supabase.auth.signInWithPassword({ email, password });
    if (error) {
      setError(error.message);
      setLoading(false);
    } else {
      onLogin(data.session);
      setLoading(false);
    }
  };

  const handleForgotPassword = async () => {
    if (!email) {
      setError('Enter your email address above first.');
      return;
    }
    setLoading(true);
    setError(null);
    const { error } = await supabase.auth.resetPasswordForEmail(email, {
      redirectTo: window.location.origin,
    });
    if (error) {
      setError(error.message);
    } else {
      setResetSent(true);
    }
    setLoading(false);
  };

  return (
    <div className="login-screen">
      <div className="login-inner">
        <div className="login-logo">
          <span className="logo-audee">Audee<span className="logo-dot">.</span></span>
        </div>
        <p className="login-subtitle">Estimate auditing. Automated.</p>
        <div className="login-stats">
          <span className="login-stat">Xactimate &amp; T&amp;M</span>
        </div>

        {onBack && (
          <button onClick={onBack} style={{ background: 'none', border: 'none', color: 'var(--text-muted)', fontFamily: 'var(--mono)', fontSize: '11px', cursor: 'pointer', marginBottom: '8px' }}>
            Back to Home
          </button>
        )}

        <div className="login-mode-toggle">
          <button
            className={"login-mode-btn " + (mode === 'signup' ? 'active' : '')}
            onClick={() => { setMode('signup'); setError(null); setResetSent(false); }}
            type="button"
          >
            Sign up
          </button>
          <button
            className={"login-mode-btn " + (mode === 'login' ? 'active' : '')}
            onClick={() => { setMode('login'); setError(null); setResetSent(false); }}
            type="button"
          >
            Sign in
          </button>
        </div>

        {mode === 'signup' && (
          <form className="login-form" onSubmit={handleSignUp}>
            <div className="login-field">
              <label>Email</label>
              <input type="email" value={email} onChange={e => setEmail(e.target.value)} placeholder="your@email.com" required autoComplete="email" />
            </div>
            <div className="login-field">
              <label>Password</label>
              <input type="password" value={password} onChange={e => setPassword(e.target.value)} placeholder="Create a password" required autoComplete="new-password" />
            </div>
            <p className="login-magic-hint">3 free audits included. No credit card required.</p>
            {error && (
              <div className="login-error" style={{ color: error === 'check_email' ? 'var(--green-text)' : 'var(--red-text)' }}>
                {error === 'check_email' ? '✓ Check your email to confirm your account, then sign in.' : '⚠ ' + error}
              </div>
            )}
            <button className="login-btn" type="submit" disabled={loading}>
              {loading ? 'Creating account...' : 'Start Free Trial'}
            </button>
          </form>
        )}

        {mode === 'login' && (
          <form className="login-form" onSubmit={handleLogin}>
            {signedOutNotice && <SessionNotice kind="signed_out" />}
            <div className="login-field">
              <label>Email</label>
              <input type="email" value={email} onChange={e => setEmail(e.target.value)} placeholder="your@email.com" required autoComplete="email" />
            </div>
            <div className="login-field">
              <label>Password</label>
              <input type="password" value={password} onChange={e => setPassword(e.target.value)} placeholder="••••••••" required autoComplete="current-password" />
            </div>
            {error && <div className="login-error">⚠ {error}</div>}
            <button className="login-btn" type="submit" disabled={loading}>
              {loading ? 'Signing in...' : 'Sign In'}
            </button>
            {resetSent ? (
              <div className="login-reset-sent">✓ Password reset email sent — check your inbox.</div>
            ) : (
              <button type="button" className="login-forgot-btn" onClick={handleForgotPassword} disabled={loading}>
                Forgot password?
              </button>
            )}
          </form>
        )}
      </div>
    </div>
  );
}

export default LoginScreen;
